import React, { useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import ReportsTable from '../../../components/tables/ReportsTable';

const ReportsTopUpHistory = () => {
  const navigate = useNavigate();

  const generateSampleData = (count = 70) => {
    const statuses = ['Submitted', 'Approved', 'Rejected'];
    const actions = ['Distributor Ops', 'Finance Desk', 'Support Lead'];
    const retailers = Array.from({ length: 25 }, (_, index) => ({
      code: `RET${String(index + 1).padStart(4, '0')}`,
      name: `Retailer ${index + 1}`,
    }));

    return Array.from({ length: count }, (_, index) => {
      const retailer = retailers[Math.floor(Math.random() * retailers.length)];
      const requestDate = new Date(
        2025,
        Math.floor(Math.random() * 10),
        Math.floor(Math.random() * 28) + 1
      );
      const actionDate = new Date(requestDate);
      actionDate.setDate(actionDate.getDate() + Math.floor(Math.random() * 3));
      const status = statuses[Math.floor(Math.random() * statuses.length)];

      return {
        requestId: `DTH${String(index + 1).padStart(6, '0')}`,
        requestDate: requestDate.toISOString().split('T')[0],
        actionDate: actionDate.toISOString().split('T')[0],
        retailerCode: retailer.code,
        retailerName: retailer.name,
        amount: [8500, 12500, 19500, 22500, 27500, 30500, 36500][Math.floor(Math.random() * 7)],
        mode: ['NEFT', 'RTGS', 'IMPS', 'UPI'][Math.floor(Math.random() * 4)],
        status,
        actionBy: status === 'Submitted' ? '-' : actions[Math.floor(Math.random() * actions.length)],
        remarks:
          status === 'Rejected'
            ? ['UTR mismatch', 'Exceeded assigned limit', 'Document proof pending'][Math.floor(Math.random() * 3)]
            : status === 'Approved'
            ? ['Credited to wallet', 'Verified & released', 'Processed with priority'][Math.floor(Math.random() * 3)]
            : 'Awaiting review',
      };
    });
  };

  const [data] = useState(generateSampleData(80));

  const columns = [
    { key: 'status', label: 'Status' },
    { key: 'requestId', label: 'Request ID' },
    { key: 'requestDate', label: 'Request Date' },
    { key: 'actionDate', label: 'Action Date' },
    { key: 'retailerCode', label: 'Retailer Code' },
    { key: 'retailerName', label: 'Retailer Name' },
    { key: 'amount', label: 'Amount (₹)' },
    { key: 'mode', label: 'Mode' },
    { key: 'actionBy', label: 'Action By' },
    { key: 'remarks', label: 'Remarks' },
  ];

  return (
    <Container fluid>
      <div className="mb-3">
        <Button
          variant="outline-secondary"
          size="sm"
          onClick={() => navigate('/distributor/top-up-request/from-retailer')}
          style={{
            padding: '0.5rem 1rem',
            fontSize: '0.875rem',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            width: 'fit-content',
          }}
        >
          <i className="bi bi-arrow-left"></i> Back
        </Button>
      </div>

      <ReportsTable
        data={data}
        reportType="Distributor_TopUpHistory"
        columns={columns}
        title="Top-Up Request History"
      />
    </Container>
  );
};

export default ReportsTopUpHistory;

